import { useEffect } from "react";

import { PageView } from "components/materials/page/PageView";
import { useAppDispatch } from "store";
import { viewStateActions } from "store/slices/view";
import { useParams } from "utils/routing";

export default function Page() {
  const dispatch = useAppDispatch();
  const pathParams = useParams();
  const pageId = pathParams.pageId;

  useEffect(() => {
    dispatch(viewStateActions.setCurrentPageId(pageId ?? null));
  }, [dispatch, pageId]);

  useEffect(() => {
    return () => {
      dispatch(viewStateActions.setCurrentPageId(null));
    };
  }, [dispatch]);

  return <PageView pageId={pageId} />;
}
